<template>
    <Dialog v-model:visible="visible" :draggable="false" position="top" modal :style="{ width: '50rem' }"
        id="EasyGiftDialog">
        <template #header>
            <div class="inline-flex items-center justify-center  align-items-center">

                <span class="font-bold whitespace-nowrap" id="EasyGiftDialog_title">
                    {{ $t('gifts.send') }}
                    <Avatar :image="target.avatar" shape="circle" /> {{ target.nickname }}
                </span>
            </div>
        </template>
        <div class="p-fluid">
            <div v-for="gift in gifts" :key="gift._id" class="gift-item">
                <img :src="gift.image" @click="selectedGift = gift._id">
                <RadioButton v-model="selectedGift" :inputId="gift._id.toString()" name="dynamic" :value="gift._id" />
                <label :for="gift._id" class="ml-2"> {{ gift.price }}</label>
            </div>
        </div>
        <template #footer>
            <Button :label="$t('gifts.cancel')" text severity="secondary" @click="visible = false" autofocus />
            <Button :label="$t('gifts.send')" icon="pi pi-send" outlined severity="success" :disabled="!selectedGift" autofocus @click="sendGift()" />
        </template>
    </Dialog>
</template>
<script>
export default {
    name: "Gift",
    props: ['gifts'],
    data() {
        return {
            target: null,
            visible: false,
            selectedGift: 0,
        }
    },
    methods: {
        setTarget(user) {
            this.target = user;
            this.visible = true;
        },
        sendGift() {
            this.$socket.emit('sendGift', { target: this.target.user_id, gift: this.selectedGift });
            this.visible = false;
        }
    },

}
</script>

<style scoped>


.gift-item {
    width: 82px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    float: left;
    margin-bottom: 20px;
}

.gift-item img {
    width: 82px;
}

.gift-item label {
    margin: 0 !important;
}
</style>